import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-48 (BU-10) 10c — per-task portal sign-off from the Scoping table column.
 * Proxies through graphql/ to the portal internal admin API.
 */
const mutation = graphql`
	mutation updateTaskPortalConfigMutation($input: UpdateTaskPortalConfigInput!) {
		updateTaskPortalConfig(input: $input) {
			taskPortalConfig {
				requiresClientSignoff
				signoffApproverPortalUserId
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
